import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';

const RegisterPress = (props) => (
  <div className="Register">
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder="Email"
      icon="at"
      focus
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />

    <div className="step">Step 3: Complete your profile.</div>
    <h1>
      <b>Tell Us About Yourself</b>
    </h1>
    <hr className="short" />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder="Publication Name"
      icon="home"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_title"
      fieldPlaceholder="Title"
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_city"
      fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_state"
      fieldPlaceholder={i18n.translate('loginScreen.fields.stateProvince')}
      icon="map"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="text"
      fieldName="reg_zip_code"
      fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
      icon="map"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="tel"
      fieldName="reg_phone_number"
      fieldPlaceholder={i18n.translate('loginScreen.fields.phone')}
      icon="phone"
    />

    <h1>
      <b>Describe Your Business</b>
    </h1>
    <hr className="short" />

    <p htmlFor="reg_agency_business" className="spacer">
      Describe your Business
    </p>
    <select id="reg_agency_business" name="reg_agency_business" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Travel Trade Media">Travel Trade Media</option>
      <option value="Other Digital Media">Other Digital Media</option>
      <option value="Freelancer">Freelancer</option>
      <option value="Influencer">Influencer</option>
      <option value="Other">Other</option>
      <option value="Not Applicable">Not Applicable</option>
    </select>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_website"
      fieldPlaceholder="What is the URL for your company?"
      icon="building"
    />

    <div className="Register__type hide">
      <p id="pMan">{i18n.translate('loginScreen.fields.manager')}</p>
      <label htmlFor="manager">
        <input
          onChange={props.change}
          id="manager"
          type="radio"
          name="registration_manager"
          value="manager"
          required={false}
        />
        <span>Yes</span>
      </label>
      <label htmlFor="noManager">
        <input
          onChange={props.change}
          id="noManager"
          type="radio"
          name="registration_manager"
          value="noManager"
          required={false}
        />
        <span>No</span>
      </label>
    </div>

    <InputField
      change={props.change}
      fieldLabel="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      fieldName="marketing_opt_in"
      fieldType="checkbox"
      icon="clipboard-check"
      userSelect={false}
      line={false}
      title="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      defaultSelected
    />

    <div className="login__form--buttons">
      <button type="submit" onClick={props.submit} className="Email__input--button">
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          i18n.translate('loginScreen.register')
        )}
      </button>
    </div>
  </div>
);

export default RegisterPress;

RegisterPress.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

RegisterPress.defaultProps = {
  defaultVal: '',
};
